<template>
  <div class="talent-pool-content" v-if="hasTalentPoolPermission">
    <div class="header-container">
      <span class="title">{{ $t(`${i18nPrefix}.containerTitle.talentPool`) }}</span>
      <el-button class="more-btn" type="primary" @click="handelToTalentPool">{{ $t(`${i18nPrefix}.btn.more`) }}</el-button>
    </div>
    <div class="body-container">
      <ul class="talent-pool-content-ul" :class="talentPoolList.length < 2 && 'single'">
        <li
          v-for="(item, index) in talentPoolList"
          class="talent-pool-content-li"
          :key="index"
        >
          <TalentPool
            :class="talentPoolList.length < 2 && 'single'"
            :title="item.title"
            :number="item.number"
            :dataList="item.data"
            :groupName="item.groupName"
            :groupID="item.groupID"
          />
        </li>
      </ul>
      <div v-show="talentPoolList.length > 1" class="divider"></div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import TalentPool from './talentPoolStatusContainer.vue'
import mixin from './mixin'

export default {
  mixins: [mixin],
  components: {
    TalentPool
  },
  data () {
    return {
      i18nPrefix: 'admin.hrDashboard',
      talentPoolList: [
        {
          title: 'my',
          number: 0,
          data: [],
          groupName: '',
          groupID: 0
        },
        {
          title: 'all',
          number: 0,
          data: [],
          groupName: '',
          groupID: 0
        }
      ],
      currentUserID: ''
    }
  },
  computed: {},
  async created () {
    this.currentUser = this.getCurrentAccount().id
    await this.getTalentFilterGroupList()
  },
  methods: {
    ...mapActions('talent', ['searchTalentFilterGroup']),
    ...mapGetters('account', ['getCurrentAccount']),
    async getTalentFilterGroupList () {
      const resp = await this.searchTalentFilterGroup({
        creator: this.currentUser,
        visibility: 'all'
      })
      const allGroupData = resp.default_group
      allGroupData.name = ''
      allGroupData.title = 'all'
      const myGroupData = resp.user_groups[0] || {}
      myGroupData.title = 'my'
      this.talentPoolList = _.chain([myGroupData, allGroupData])
        .map(item => {
          const report = item.report
          return {
            report: report,
            title: item.title,
            number: report?.total_count,
            data: report?.items,
            groupName: item.name,
            groupID: item.id
          }
        })
        .filter('report')
        .value()
    },
    handelToTalentPool () {
      this.$router.push('/v-admin/talent-pool/talent-filter-group/')
    }
  }
}
</script>

<style lang="scss" scoped>
.talent-pool-content {
  background: #FFFFFF;
  border-radius: 6px;
  color: #303133;
  font-weight: 500;
  margin-bottom: 15px;

  .header-container {
    padding: 20px 24px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 18px;
      height: 25px;
      line-height: 25px;
      font-weight: bold;
    }

    .more-btn {
      padding: 2px 12px;
      height: 26px;
      background-color: #0096cc;
      font-weight: 400;
    }
  }

  .body-container {
    position: relative;

    .talent-pool-content-ul {
      display: flex;
      justify-content: space-between;
      &.single {
        .talent-pool-content-li {
          width: 100%;
        }
      }
      .talent-pool-content-li {
        padding: 20px;
        width: 49.1%;
        background: #fff;
      }
    }

    .divider {
      height: 180px;
      position: absolute;
      left: 50%;
      right: 50%;
      bottom: 38px;
      width: 0;
      border: 1px solid #DCDFE6;
    }
  }
}
</style>
